var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex",attrs:{"id":"wrapper"}},[_c('Header',{on:{"menu_v":_vm.menu_status}}),_c('div',{attrs:{"id":"page-content-wrapper"}},[_c('location',{attrs:{"menu_status":_vm.menu_visible}}),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }